export default {
  // 画高架快速路
  drawHighway(currentMap) {
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getDB", {
        params: {
          dataContent: "HighwayModel",
          projection: "-_id",
        },
      })
      .then(function (res) {
        console.log("画高架快速路", res);
        let lineList = res.data.data;
        for (let i = 0; i < lineList.length; i++) {
          let loc = lineList[i];

          let strokeStyle = "solid";
          if (loc.type === "隧道") {
            strokeStyle = "dashed";
          }
          let strokeColor = "#000000";
          if (loc.type === "高速") {
            strokeColor = "#0000CD";
          }

          // 线路
          let dots = loc.dots.split("-").map((x) => {
            return x.split("|");
          });

          for (let k = 0; k < dots.length; k++) {
            if (k % 10 === 5) {
              let text = new AMap.Text({
                zIndex: 55,
                text: loc.name,
                textAlign: "center",
                verticalAlign: "middle",
                style: {
                  // 'padding': '.20rem .50rem',
                  // 'border-radius': '.25rem',
                  "background-color": strokeColor,
                  "border-width": 0,
                  // 'margin-top': '1rem',
                  "font-size": "10px",
                  "line-height": "10px",
                  color: "#ffffff",
                },
                position: dots[k],
              });
              text.setMap(currentMap);
            }
          }

          let polyline = new AMap.Polyline({
            path: dots,
            strokeWeight: 4, // 线条宽度，默认为 1
            strokeColor: strokeColor, // 线条颜色
            strokeStyle: strokeStyle,
            strokeOpacity: 1,
            lineJoin: "round", // 折线拐点连接处样式
          });
          currentMap.add(polyline);
        }
      })
      .catch(function (res) {
        console.log("查询地铁线路失败", res);
      });
  },

  drawValueMap(currentMap) {
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getValueMapData", {
        params: {
          estate_id: that.estate_id,
          type: that.valueType,
        },
      })
      .then((res) => {
        let realEstate = res.data.data;
        console.log("realEstate", realEstate);

        // 八公里范围
        var circle = new AMap.Circle({
          center: realEstate.lnglat.split("-")[0].split("|"), // 圆心位置
          radius: 8000, // 圆半径
          fillColor: "red", // 圆形填充颜色
          strokeColor: "#fff", // 描边颜色
          strokeWeight: 2, // 描边宽度
          fillOpacity: 0.2,
        });
        currentMap.add(circle);
        let marker = new AMap.Marker({
          position: realEstate.lnglat.split("-")[0].split("|"),
          label: {
            content: "本楼盘",
          },
          draggable: true,
        });
        marker.setMap(currentMap);

        let major = realEstate.major;
        for (let i = 0; i < major.length; i++) {
          let content = major[i].location_name;
          if (major[i].location_size) {
            content = `${content}（${major[i].location_size}）`;
          }
          if (that.valueType === "daogua") {
            content = major[i].real_estate_name;
            if (major[i].price) {
              content = `${content}（${major[i].price}）`;
            }
          }
          let marker = new AMap.Marker({
            position: major[i].lnglat.split("-")[0].split("|"),
            label: {
              content: content,
            },
            draggable: true,
          });
          marker.setMap(currentMap);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  },

  drawKCDZL(currentMap) {
    let that = this;
    that.$axios.get(that.$url_prefix + "getZZPHData").then((res) => {
      let data = res.data.data;
      let dots = data.dots;
      let polygon1 = new AMap.Polygon({
        // 范围线
        zIndex: 300,
        map: currentMap,
        strokeWeight: 5,
        path: dots,
        fillOpacity: 0,
        strokeColor: "#383838",
        strokeOpacity: 1,
        fillOpacity: 0.8,
        fillColor: "#ffffff",
      });
      let mapData = {};
      let list = data.realList;
      for (let i = 0; i < list.length; i++) {
        let loc = list[i];
        let markerContent = "";
        let piece = loc.piece;
        let judge = "#edd716"; // 不是地铁盘
        if (loc.sub == 1) {
          judge = "#ff8f8f"; // 地铁盘
        } else if (loc.sub == 2) {
          judge = "#bbd0f8"; // 四期地铁盘
        }
        let expect = "";
        if (that.type == "公示登记") {
          judge = "#b2d0e6";
          if (loc.state == "正在公示" || loc.state == "已拿预售证") {
            judge = "#ff4769";
          } else if (loc.state == "正在登记") {
            judge = "#ff4769";
          } else if (loc.ex) {
            judge = "#a8e98e";
          }
        } else {
          if (loc.ex) {
            expect = `<div class="expect">${loc.ex}</div>`;
          }
        }

        piece.forEach((x) => {
          if (x.price1) {
            x.price = x.price1;
          }
        });
        piece.sort((a, b) => {
          return a.price - b.price;
        });
        let priceLen = piece.length;
        if (priceLen === 0) {
          markerContent = `
              <div class="newEstate">
                <div class="realPrice" style="background-color:${judge}">
                  <div>${loc.real_estate_name}</div>
                </div>
                ${expect}
              </div>
              `;
        } else if (priceLen === 1) {
          markerContent = `
              <div class="newEstate">
                <div class="realPrice" style="background-color:${judge}">
                  <div>${loc.real_estate_name}</div>
                  <div class="realPrice-c">${piece[0].type}${piece[0].price}</div>
                </div>
                ${expect}
              </div>
              `;
        } else if (priceLen === 2) {
          markerContent = `
              <div class="newEstate">
                <div class="realPrice" style="background-color:${judge}">
                  <div>${loc.real_estate_name}</div>
                  <div class="realPrice-c">${piece[0].type}${piece[0].price}</div>
                  <div class="realPrice-c">${piece[1].type}${piece[1].price}</div>
                </div>
                ${expect}
              </div>
              `;
        } else if (priceLen > 2) {
          markerContent = `
              <div class="newEstate">
                <div class="realPrice" style="background-color:${judge}">
                  <div>${loc.real_estate_name}</div>
                  <div class="realPrice-c">${piece[0].type}${piece[0].price}</div>
                  <div class="realPrice-c">${piece[1].type}${piece[1].price}</div>
                  <div class="realPrice-c">${piece[2].type}${piece[2].price}</div>
                </div>
                ${expect}
              </div>
              `;
        }

        let realPos = loc.lnglat.split("|");
        let position = realPos;
        if (loc.move) {
          position = loc.move.split("|");
          mapData[loc.id] = {
            marker: realPos,
            line: [realPos, position],
          };
        }

        let nameLen = loc.real_estate_name.length;
        if (nameLen <= 6 && priceLen > 0) {
          nameLen = 6.5;
        }
        let offsetX = -nameLen * 10;
        let offsetY = -(priceLen + 1) * 15;

        let marker = new AMap.Marker({
          real_id: loc.id,
          position: position,
          content: markerContent,
          offset: new AMap.Pixel(offsetX, offsetY),
          draggable: true,
        });

        marker.setMap(currentMap);
      }
      that.realMarkers = mapData;
    });
  },

  drawDaoguaAll(currentMap) {
    console.log("倒挂地图");
    let that = this;
    that.$axios
      .post(that.$url_prefix + "getDaoguaNewEstate")
      .then((res) => {
        console.log("getDaoguaNewEstate", res);
        let data = res.data;
        if (data && data["newEstates"] && data["newEstates"].length) {
          for (let i = 0; i < data["newEstates"].length; i++) {
            let temp = data["newEstates"][i];
            let judge = "#ff000e";
            if (temp.daogua && temp.daogua != "暂无倒挂") {
              let markerContent = `<div class="shape-container>
                  <div class="rectangle1" style="background-color:${judge}; border-radius: 12px;">
                    <div class="reclight1">${temp.real_estate_name}</div>`;
              if (temp.priceArr && temp.priceArr.length > 0) {
                for (let index = 0; index < temp.priceArr.length; index++) {
                  const element = temp.priceArr[index];
                  markerContent += `<div class="reclight1">${element}</div>`;
                }
              } else {
                markerContent += `<div class="reclight1">暂无价格</div>`;
              }
              if (temp.daogua) {
                if (temp.daogua != "暂无倒挂")
                  markerContent += `<div class="reclight1">倒挂${temp.daogua}元/m²</div>`;
                else if (
                  (temp.priceArr[0] && temp.priceArr[0] != "价格待定") ||
                  !temp.priceArr[0]
                )
                  markerContent += `<div class="reclight1">${temp.daogua}</div>`;
              }

              markerContent += `</div>
                  </div>`;

              let marker = new AMap.Marker({
                position: temp.lnglat.split("-")[0].split("|"),
                content: markerContent,
                offset: new AMap.Pixel(0, 0),
                draggable: true,
              });
              marker.setMap(currentMap);
            }
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  },

  drawBaseCover(currentMap) {
    let path = [
      [119.632352, 30.50275],
      [119.518179, 29.887703],
      [120.662711, 29.936138],
      [120.648561, 30.507006],
    ];
    if (this.currentArea !== "全城") {
      let bounds = currentMap.getBounds();
      let northeast = bounds.northeast;
      let southwest = bounds.southwest;
      path = [
        [northeast.lng, northeast.lat],
        [northeast.lng, southwest.lat],
        [southwest.lng, southwest.lat],
        [southwest.lng, northeast.lat],
      ];
    }
    let polygon = new AMap.Polygon({
      path: path,
      fillOpacity: 0.2,
      fillColor: "#979591",
      strokeWeight: 1,
      strokeOpacity: 0,
      strokeColor: "#383838",
    });
    currentMap.add(polygon);
  },

  drawBaseCover2(currentMap) {
    let bounds = currentMap.getBounds();
    let northeast = bounds.northeast;
    let southwest = bounds.southwest;
    let path = [
      [northeast.lng, northeast.lat],
      [northeast.lng, southwest.lat],
      [southwest.lng, southwest.lat],
      [southwest.lng, northeast.lat],
    ];
    let polygon = new AMap.Polygon({
      path: path,
      fillOpacity: 1,
      fillColor: "#ffffff",
      strokeWeight: 1,
      strokeOpacity: 0,
      strokeColor: "#383838",
    });
    currentMap.add(polygon);
  },
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindSpecial.js